import { Component } from "@angular/core";

@Component({
    selector: "[pcg-ng-spinner]",
    templateUrl: "./spinner.component.html",
    host: {
        "class": "pcg-spinner"
    },
    providers: []
})
export class SpinnerComponent {

}
